import React from 'react';
import { AdvertorialButton } from '../ui/AdvertorialButton';
export function WhyStickersSection() {
  return <section className="w-full py-8 md:py-12 lg:py-16 px-4 md:px-6" style={{
    background: 'linear-gradient(135deg, #F0F7FF 0%, #FFFFFF 100%)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }} data-id="element-266">
      <div className="max-w-4xl mx-auto" data-id="element-267">
        <h2 className="text-[29px] md:text-[34px] lg:text-[43px] font-bold mb-10 text-center" style={{
        color: '#1B4F9E'
      }} data-id="element-268">
          WHY EMF STICKERS WON (Comparison of All Options)
        </h2>

        <div className="flex justify-center mb-10" data-id="element-269">
          <img src="https://cdn.magicpatterns.com/uploads/g3NcQHRQQix1ZrxBEgPvtv/unnamed_(12).jpg" alt="Verified EMF Stickers - Protection From All Devices" className="w-full max-w-lg rounded-xl shadow-md" data-id="element-270" />
        </div>

        <p className="text-base md:text-lg font-semibold mb-6" style={{
        color: '#1B4F9E'
      }} data-id="element-271">
          When families discovered their sleep disruption might be connected to
          EMF, they had options:
        </p>

        <div className="mb-8" data-id="element-272"></div>

        <div className="text-base md:text-lg leading-relaxed space-y-6" style={{
        color: '#2C3E50',
        lineHeight: '1.7'
      }} data-id="element-273">
          <div data-id="element-274">
            <p className="font-bold mb-2" data-id="element-275">
              Option 1: Eliminate devices — Throw out WiFi, ban smartphones,
              remove smart meters
            </p>
            <p data-id="element-276">
              <strong data-id="element-277">Reality:</strong> Impossible. Kids need devices for
              school. WiFi is everywhere. Smart meters are mandatory.
            </p>
            <p data-id="element-278">
              <strong data-id="element-279">Result:</strong> Doesn't work.
            </p>
          </div>

          <div data-id="element-280">
            <p className="font-bold mb-2" data-id="element-281">
              Option 2: Device limiting — Strict screen time schedules, no
              phones in bedrooms, WiFi on timers
            </p>
            <p data-id="element-282">
              <strong data-id="element-283">Reality:</strong> Helps somewhat, but doesn't eliminate
              exposure (smart meters still transmit, neighbors' WiFi penetrates
              walls, 5G from towers passes through)
            </p>
            <p data-id="element-284">
              <strong data-id="element-285">Result:</strong> Partial solution only.
            </p>
          </div>

          <div data-id="element-286">
            <p className="font-bold mb-2" data-id="element-287">
              Option 3: EMF Stickers on devices — Single application, invisible,
              measurable with meters
            </p>
            <p data-id="element-288">$30 for whole family</p>
            <p data-id="element-289">
              <strong data-id="element-290">Reality:</strong> Works on primary exposure sources
              (phones, tablets, routers), invisible to others, one-time
              application
            </p>
            <p data-id="element-291">
              Practical, affordable, verifiable. This is what 1,000+ families
              chose.
            </p>
            <div className="mt-6 -mx-4 md:-mx-6" data-id="element-292">
              <img src="https://cdn.magicpatterns.com/uploads/aBaCMY2wQVwgiYUCyeYDUL/unnamed_(6).jpg" alt="Trusted by 1,000+ Australian Families" className="w-full rounded-lg shadow-md" data-id="element-293" />
            </div>

            {/* BOGO Offer Section */}
            <div className="mt-6 rounded-xl overflow-hidden shadow-md border border-blue-100" style={{
            background: 'linear-gradient(135deg, #1B4F9E 0%, #163d7a 100%)'
          }} data-id="element-294">
              {/* Urgency Banner */}
              <div className="bg-[#2D9B6E] text-white text-center py-1.5 px-4 text-xs font-bold tracking-widest uppercase" data-id="element-295">
                ⏰ Limited Time — Ends Tonight
              </div>

              <div className="p-5 text-center" data-id="element-296">
                {/* Headline */}
                <h3 className="text-2xl font-bold text-white mb-1" data-id="element-297">
                  Buy 1 Pack, Get 1 Free
                </h3>
                <p className="text-blue-200 text-sm mb-4" data-id="element-298">
                  $30 · 2 packs · No code needed
                </p>

                {/* CTA */}
                <AdvertorialButton href="https://VitaleneHealth.com" variant="primary" className="text-sm w-full sm:w-auto" data-id="element-299">
                  Claim My Free Pack →
                </AdvertorialButton>

                {/* Trust line */}
                <p className="mt-3 text-blue-300 text-xs" data-id="element-300">
                  ✓ Free shipping · ✓ 30-day guarantee · ✓ 1,000+ families
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Conclusion */}
        <div className="mt-10 text-base md:text-lg font-medium" style={{
        color: '#1B4F9E',
        lineHeight: '1.7'
      }} data-id="element-301"></div>
      </div>
    </section>;
}